module.exports = __webpack_public_path__ + "img/title.a6a4f86d.png";